import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { AnalyticsService } from './analytics.service';

@Injectable()
export class NavigationAnalyticsService {
  constructor(private analytics: AnalyticsService) {}

  reportPageView(event: NavigationEnd) {
    this.analytics.config({ page_path: event.urlAfterRedirects });
  }
}
